import { PosMarketingMode, PosSystems } from "../enums";
import { LoyaltyProgramSettingsGetDto } from "./loyalty-program";

export interface CovaPosSystemSettings extends PosSystemSettingsBase {
  clientId: string;
  clientSecret: string;
  userName: string;
  password: string;
}
export interface CloverPosSystemSettings extends PosSystemSettingsBase {}
export interface SurgePosSystemSettings extends PosSystemSettingsBase {}
export interface PaxPosSystemSettings extends PosSystemSettingsBase {}
export type AccountPosSystemSettingsConfiguration =
  | CloverPosSystemSettings
  | CovaPosSystemSettings
  | SurgePosSystemSettings
  | PaxPosSystemSettings;

export interface AccountPosSystemSettingsDto {
  companyPosId: string;
  posSystemId: number;
  configurationJson: AccountPosSystemSettingsConfiguration | string;
}

export class AccountPosSystemSettings {
  public companyPosId!: string;
  public posSystemId!: PosSystems;
  public configuration!: AccountPosSystemSettingsConfiguration;

  public static fromDto(dto: AccountPosSystemSettingsDto): AccountPosSystemSettings {
    const configurationJson: string = dto.configurationJson === "null" ? "{}" : (dto.configurationJson as string);
    const model: AccountPosSystemSettings = { ...dto, configuration: JSON.parse(configurationJson) };
    model.configuration.posSystemId = dto.posSystemId;
    return model;
  }
}

export interface PosSystemSettingsBase {
  cfs?: PosCfsSettingsDto;
  posSystemId: PosSystems;
  isTransactionsEnabled: boolean;
  isPosRulesEnabled: boolean;
  isProductsImportEnabled: boolean;
  isReceiptPromotionEnabled: boolean;
  isCouponsEnabled: boolean;
  isUserDataSendingToPosEnabled: boolean;
  posMarketingMode: PosMarketingMode;
  loyaltyAutomaticCalculationSettings: LoyaltyProgramSettingsGetDto;
}

export interface PosCfsSettingsDto {
  isCheckInMenuAvailable: boolean;
}
